import styled from '@themes/theme'

export const UsageGuideVideoWrap = styled.div`
  .usage-guide-video-popup__content {
    background: ${props => props.theme.color.themeTxt};
  }
  
  .usage-guide-video-popup__video-wrap {
    position: relative;
    width: 100%;
    background: #000;
    padding-bottom: 60px;

    video {
      display: block;
      width: 100%;
      height: calc(100dvh - 45px - 4px - 15px - 60px); // 화면높이 - 헤더 - 프로그래스바 - 상단여백 - 하단여백
      object-fit: contain;
    }

    .usage-guide-video-popup__error-fallback {
      width: 100%;
      height: 100%;
      background: #000;
    }

    .usage-guide-video-popup__interaction-blocker {
      position: absolute;
      z-index: 1;
      inset: 0;
      cursor: default;
    }

    .usage-guide-video-popup__progress {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 15px;

      .usage-guide-video-popup__progress-track {
        width: 100%;
        height: 4px;
        background: ${props => props.theme.color.subColor2};
      }

      .usage-guide-video-popup__progress-bar {
        height: 100%;
        border-radius: 0 10px 10px 0;
        background: #AF0;
        transition: width 0.2s linear;
        &.full {
          border-radius: 0;
        }
      }
    }
    
    &.pc {
      padding-bottom: 45px;
      video {
        height: calc(75dvh - 45px - 4px - 45px);
      }
      .usage-guide-video-popup__progress {
        margin-bottom: 0;
      }
    }
  }
  
  .usage-guide-video-popup__confirm {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 45px;
    border-radius: 0;
    background-color: ${props => props.theme.color.primaryBg};
    color: ${props => props.theme.color.themeTxt};
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.bold};
  }
`
